import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import SessionBlocksPlannerController from "./session_blocks_planner_controller"
application.register("session-blocks-planner", SessionBlocksPlannerController)

import StudentProfileTabsController from "./student_profile_tabs_controller"
application.register("student-profile-tabs", StudentProfileTabsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ProgramSkillFormController from "./program_skill_form_controller"
application.register("program-skill-form", ProgramSkillFormController)

import LessonFormController from "./lesson_form_controller"
application.register("lesson-form", LessonFormController)

import LessonSkillsController from "./lesson_skills_controller"
application.register("lesson-skills", LessonSkillsController)

import IntervalRecordingController from "./interval_recording_controller"
application.register("interval-recording", IntervalRecordingController)

import LatencyRecordingController from "./latency_recording_controller"
application.register("latency-recording", LatencyRecordingController)

import LiveSessionController from "./live_session_controller"
application.register("live-session", LiveSessionController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import LessonsCancelModalController from "./lessons_cancel_modal_controller"
application.register("lessons-cancel-modal", LessonsCancelModalController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import SkillsTableController from "./skills_table_controller"
application.register("skills-table", SkillsTableController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import InvitationFormController from "./invitation_form_controller"
application.register("invitation-form", InvitationFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import StopwatchController from "./stopwatch_controller"
application.register("stopwatch", StopwatchController)

import SkillLevelFilterController from "./skill_level_filter_controller"
application.register("skill-level-filter", SkillLevelFilterController)
